import { ListPickupV2ApiRepository } from "@/app/infrastructures/repositories/api/ListPickupV2ApiRepository";
import {
  ListPickupParams,
  ListSttRequestPickupRequest,
  PickupCorporateSummaryRequest
} from "@/data/payload/api/ListPickupV2Request";
import { ListPickupDetail } from "@/domain/entities/ListPickupDetailV2";
import {
  PickupCorporateSummary,
  RequestListPickupDetail
} from "@/domain/entities/ListPickupV2";
import { injectable } from "tsyringe";

@injectable()
export class ListPickupV2Presenter {
  private repository: ListPickupV2ApiRepository;
  constructor(repo: ListPickupV2ApiRepository) {
    this.repository = repo;
  }

  async getListSttRequestPickup(params: ListSttRequestPickupRequest) {
    return this.repository.getListSttRequestPickup(params);
  }

  public getPickupCorporateSummary(
    params: PickupCorporateSummaryRequest
  ): Promise<PickupCorporateSummary> {
    return this.repository.getPickupCorporateSummary(params);
  }

  public getListPickupDetail(
    id: string,
    params?: RequestListPickupDetail
  ): Promise<ListPickupDetail> {
    return this.repository.getListPickupDetail(id, params);
  }

  async getListPickup(params: ListPickupParams) {
    return this.repository.getListPickup(params);
  }
}
